import { useState } from 'react';
import Validator from 'validatorjs';
import React, { useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import SiNoOptions from '../../support/catalogos/SiNoOptions'
import ComplementoInteresesRules from '../../support/rules/complementos/ComplementoInteresesRules'

const rules = ComplementoInteresesRules;

const ComplementoIntereses = (props) => {
  const [data, setData] = useState(props.data || {});
  const [validation, setValidation] = useState({
    validator: new Validator({}, rules),
    isValid: false,
  });

  const { isValid } = validation;

  const handleOnChange = (event) => {
    const newData = {
      ...data,
      ...event,
    };

    setData(newData);
  };

  const validate = (data) => {
    const validator = new Validator(data, rules);

    const newValidator = {
      validator: validator,
      isValid: validator.passes(),
    };

    setValidation(newValidator);
  };

  useEffect(() => validate(data), [data]);

  const handleOnAddComplemento = () => {
    const Intereses = {
      Version: '1.0',
      SistFinanciero: data.SistFinanciero,
      RetiroAORESRetInt: data.RetiroAORESRetInt,
      OperFinancDerivad: data.OperFinancDerivad,
      MontIntNominal: data.MontIntNominal,
      MontIntReal: data.MontIntReal,
      Perdida: data.Perdida,
    };

    props.onChange({ Intereses });

    clear();
  };

  const clear = () => {
    setData({});
  };

  const handleOutForm = () => {
    props.onCancel();
  };

  return (
    <div className="pb-4">
      <div>
          <strong className="text-black text-upper">Intereses</strong>
      </div>
      <div className="section">

        <Form autoComplete="off">
          <Row>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Sistema financiero"
                name="SistFinanciero"
                placeholder=""
                help=""
                rules={rules.SistFinanciero}
                value={data.SistFinanciero}
                options={SiNoOptions}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Intereses retirados"
                name="RetiroAORESRetInt"
                placeholder=""
                help=""
                rules={rules.RetiroAORESRetInt}
                value={data.RetiroAORESRetInt}
                options={SiNoOptions}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="select"
                label="Operaciones financieras derivados"
                name="OperFinancDerivad"
                placeholder=""
                help=""
                rules={rules.OperFinancDerivad}
                value={data.OperFinancDerivad}
                options={SiNoOptions}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Importe del interés nominal"
                name="MontIntNominal"
                placeholder=""
                help=""
                rules={rules.MontIntNominal}
                value={data.MontIntNominal}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Monto intereses real"
                name="MontIntReal"
                placeholder=""
                help=""
                rules={rules.MontIntReal}
                value={data.MontIntReal}
                onChange={handleOnChange}
              />
            </Col>
            <Col sm md={4}>
              <FormControl
                type="number"
                label="Pérdida"
                name="Perdida"
                placeholder=""
                help=""
                rules={rules.Perdida}
                value={data.Perdida}
                onChange={handleOnChange}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                variant="secondary"
                className="mr-2"
                onClick={handleOutForm}
              >
                Cancelar
              </Button>

              <Button
                variant="primary"
                disabled={!isValid}
                onClick={handleOnAddComplemento}
              >
                Agregar complemento
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default ComplementoIntereses;
